import { render, staticRenderFns } from "./CollectiveAgreementsComponent.vue?vue&type=template&id=45cea80e&scoped=true"
import script from "./CollectiveAgreementsComponent.vue?vue&type=script&lang=js"
export * from "./CollectiveAgreementsComponent.vue?vue&type=script&lang=js"
import style0 from "./CollectiveAgreementsComponent.vue?vue&type=style&index=0&id=45cea80e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cea80e",
  null
  
)

export default component.exports